var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74053 4.25H16.2595C16.3871 2.57189 17.7892 1.25 19.5 1.25C21.2108 1.25 22.6129 2.57189 22.7405 4.25H22.75V19C22.75 20.5188 21.5188 21.75 20 21.75H4C2.48122 21.75 1.25 20.5188 1.25 19V4.25H1.25947C1.38713 2.57189 2.78919 1.25 4.5 1.25C6.21081 1.25 7.61287 2.57189 7.74053 4.25ZM7.75 12.25H11.25V5.75H7.75V12.25ZM7.75 13.75V15.5C7.75 15.9142 7.41421 16.25 7 16.25C6.58579 16.25 6.25 15.9142 6.25 15.5C6.25 14.5335 5.4665 13.75 4.5 13.75C3.5335 13.75 2.75 14.5335 2.75 15.5V19C2.75 19.6904 3.30964 20.25 4 20.25H11.25V13.75H7.75ZM12.75 13.75V20.25H20C20.6904 20.25 21.25 19.6904 21.25 19V15.5C21.25 14.5335 20.4665 13.75 19.5 13.75C18.5335 13.75 17.75 14.5335 17.75 15.5C17.75 15.9142 17.4142 16.25 17 16.25C16.5858 16.25 16.25 15.9142 16.25 15.5V13.75H12.75ZM16.25 12.25V5.75H12.75V12.25H16.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficePlan);
export default __webpack_public_path__ + "static/media/office-plan.538b90530c81617668b3d34404065c03.svg";
export { ForwardRef as ReactComponent };